import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import gtIcon from '../../assets/icons/gt-icon.svg';
import gtPlusIcon from '../../assets/icons/gt-plus-icon.svg';
import { convertHexToRgba } from '../../utils/commonFunctions';
import { EVENT_TICKET_TYPES } from '../../utils/constants';

const CalendarEvent = ({ event }) => {
  const { i18n } = useTranslation();

  const imagePath =
    event.resource.icon?.formats?.thumbnail?.url || event.resource.icon?.url;

  const startTime = moment(event.start).locale(i18n.language).format('LT');
  const endTime = moment(event.end).locale(i18n.language).format('LT');

  const TopBar = ({ children, ...props }) => {
    if (event.resource.url) {
      return (
        <a
          href={event.resource.url}
          target="_blank"
          rel="noopener noreferrer"
          {...props}
        >
          {children}
        </a>
      );
    }

    return <div {...props}>{children}</div>;
  };

  return (
    <div className="event-content">
      <TopBar
        className="main-content"
        style={{
          backgroundColor: event.resource.color,
        }}
      >
        <p className="title">{event.title}</p>
        <p className="time">
          {startTime} - {endTime}
        </p>
      </TopBar>
      <div
        className="secondary-content"
        style={{
          borderColor: convertHexToRgba(event.resource.color, 0.3),
        }}
      >
        {event.resource.url && (
          <a
            href={event.resource.url}
            target="_blank"
            rel="noopener noreferrer"
            className="event-link"
            style={{ color: event.resource.color }}
          >
            mehr Informationen
          </a>
        )}
        <div className="event-bottom-container">
          <div>
            <add-to-calendar-button
              id="calendar-button"
              options="'Apple', 'Google', 'iCal', 'Outlook.com'"
              name={event.title}
              startDate={moment(event.start).format('YYYY-MM-DD')}
              endDate={moment(event.end).format('YYYY-MM-DD')}
              startTime={moment(event.start).format('HH:mm')}
              endTime={moment(event.end).format('HH:mm')}
              language={i18n.language}
              size="3"
              timeZone="currentBrowser"
              hideBackground
              trigger="click"
              hideTextLabelButton
              buttonStyle="custom"
              customCss="./add-to-calendar-btn.css"
              style={{ color: event.resource.color }}
            />
            {event.ticketType === EVENT_TICKET_TYPES.GT && (
              <img
                src={gtIcon}
                alt="GesundheitsTicket icon"
                className="ticket-type-icon"
              />
            )}
            {event.ticketType === EVENT_TICKET_TYPES.GT_PLUS && (
              <img
                src={gtPlusIcon}
                alt="GesundheitsTicket Plus icon"
                className="ticket-type-icon"
              />
            )}
          </div>
          {event.resource.icon && (
            <img
              src={`${process.env.REACT_APP_CMS_URL_IMAGE}${imagePath}`}
              alt={event.title}
              className="event-partner-logo"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CalendarEvent;
